import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import spinner from "../../images/icons/spinner.svg"

const Overlay = styled.div`
  background: url(${spinner}) center center no-repeat;
  background-size: 100px;
  background-color: ${(props) =>
    props.$background && props.$background !== "greyLight"
      ? `var(--color-${props.$background}, var(--color-grey-light))`
      : "var(--color-grey-light)"};
  opacity: 0.7;
  position: absolute;
  top: -10px;
  right: -10px;
  bottom: -10px;
  left: -10px;
  z-index: 1;
`

const SubmitOverlay = ({ background, className }) => {
  return (
    <Overlay
      $background={background}
      className={className}
      data-testid="submitoverlay"
    />
  )
}

SubmitOverlay.propTypes = {
  background: PropTypes.string,
  className: PropTypes.string,
}

export default SubmitOverlay
